import { useState, useEffect, useRef } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ArrowDown, ArrowUp, PlusCircle, Search, Trash } from 'lucide-react';
import { Modal, ModalBody } from 'reactstrap';
import moment from 'moment';
import useConfirm from '../../hooks/useConfirm';
import { useDebounce } from '../../hooks/debounce';
import AddWhiteIp from './tabs/addWhiteIp';
import { useDeletewhiteip, useWhiteipList, useCheckAdminAccess } from './api/whiteipapi';
import { logout } from '../../hooks/logout';
import PermissionDenied from '../common/permissionDenied';
import { WaitingLoader } from '../../hooks/buttonLoad';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';



function WhiteIp() {

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("desc")
    const searchText = useDebounce(search)
    const [Dialog, confirmDelete] = useConfirm()
    const deleteWhiteip = useDeletewhiteip();
    const [open, setOpen] = useState(false)
    const toggle = () => setOpen(!open)

    const { data: getWhitelistIp, isLoading } = useWhiteipList({
        page: searchText ? 0 : tempPage,
        size: tempRows,
        searchText,
        status: "whitelisted",
        sortBy: "addedAt",
        sortOrder: sortOrder
    })

    const totalRecords = getWhitelistIp?.data?.totalRecords || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);



    const deletewhiteip = async (item) => {
        const isConfirmed = await confirmDelete()
        if (isConfirmed) {
            await deleteWhiteip.mutateAsync({ _id: item.ip });
        }
    }

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'allowed-ips' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };


    const renderWhitelistIpTable = () => (
        getWhitelistIp?.data?.ips?.length > 0 ?
            <>

                {deleteWhiteip?.isLoading &&
                    <PageLoader />
                }
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ maxWidth: "60px" }} align='center'>
                                        S.NO
                                    </TableCell>
                                    <TableCell>Ip</TableCell>
                                    <TableCell>Date &amp; Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder('desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                    <TableCell align='center'>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getWhitelistIp?.data?.ips?.map((row, i) => (
                                    <TableRow key={row.name}>
                                        <TableCell align='center'>{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell>{row?.ip}</TableCell>
                                        <TableCell>{moment(row?.addedAt).format("DD/MM/YYYY | hh:mm A")}</TableCell>
                                        <TableCell align='center'>
                                            <div className='d-flex justify-content-center'>
                                                <Trash className="mx-3" size={20} onClick={() => deletewhiteip(row)} type='button' />

                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
            : <NoRecords />
    );


    let content;

    if (isLoading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <div>
                <h4>Allowed IP List</h4>
                <div className="ad_pg_bx bg-white py-4">
                    <div className='d-flex justify-content-between align-items-center mb-2'>
                        <div className='col-md-4'>
                            <div className="input-group">
                                <span className="input-group-icon">
                                    <Search size={20} color='#aaa9a9' />
                                </span>
                                <input
                                    type="text"
                                    ref={inputRef}
                                    onChange={(e) => setSearch(e.target.value)}
                                    className="form-control"
                                    placeholder="Search IP"
                                    value={search}
                                />
                            </div>
                        </div>
                        <button className='btn btn-primary d-flex align-items-center' onClick={toggle}>
                            <PlusCircle size={20} style={{ marginRight: "2px" }} /> Add IP
                        </button>
                    </div>
                    {isLoading ? <PageLoader /> : renderWhitelistIpTable()}
                </div>
                <Dialog />
                <Modal isOpen={open} toggle={toggle} centered>
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">Add IP</h1>
                        <button type="button" className="btn-close" onClick={toggle} aria-label="Close">
                            <img
                                src={require('../../assets/images/icons/close-circle.svg').default}
                                alt="close-circle"
                            />
                        </button>
                    </div>
                    <ModalBody>
                        <AddWhiteIp toggle={toggle} />
                    </ModalBody>
                </Modal>
            </div>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;


}

export default WhiteIp